import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import * as uuid from "uuid";
import {
  CHART_MODE_CHART,
  CHART_MODE_TABLE,
  CHECKBOX,
  DROPDOWN,
  NUMBER,
  PREDEFINED_LIST,
  RADIO
} from "../../../../../ducks/collapsibleTableChart";
import { QuestionIcon } from "../../../../../utils/QuestionUtils";
import CollapsibleCardHeader from "../CollapsibleCardHeader";
import HorizontalTable from "../HorizontalTable";
import TextTable from "../TextTable";
import { HeaderOptions } from "./HeaderOptions";
import NumberQuestion from "./NumberQuestion";

const CSVTypeQuestion = ({
  table,
  subquestion,
  subQuestionTitle,
  csvQuestionDetails,
  modalSelectParameters,
  status,
  label,
  percentage,
  renderChart,
  renderPivotBreadcrumb,
  renderTooltips,
  handleClickDownloadPivotQuestion,
  handleModalOpen,
  handlePivotShortcutSubmit,
  handleBeginningClick,
  handlePercentageClick,
  getQuestionPath,
  getBreadcrumbPath,
  pivotShortcut,
  sinceBeginning
}) => {
  const parameters = modalSelectParameters[table.questionId];

  let questionTitle = subQuestionTitle ? subQuestionTitle : table.questionTitle;
  let iconClass = subquestion ? subquestion.questionType : table.questionType;
  let isSubQuestion = subquestion && subquestion.tableIdentifier;
  let questionType = table.questionType;
  const isChoiceQuestion = [RADIO, CHECKBOX, DROPDOWN, PREDEFINED_LIST].includes(questionType);
  let questionDetails;

  if (!isSubQuestion && csvQuestionDetails[0]?.questionId === table.questionId) {
    questionDetails = csvQuestionDetails[0].anwser.data;
  }

  const [chartMode, setChartMode] = useState();

  const handleSelectChartMode = () => {
    setChartMode(CHART_MODE_CHART);
  };

  const handleSelectTableMode = () => {
    setChartMode(CHART_MODE_TABLE);
  };

  const renderCSVTypeTable = (table, csvQuestionDetails, questionType, questionDetails, firstColumnTitle, tableId) => {
    let selectedYears = label ? [...label] : [];
    return (
      <>
        {table && !csvQuestionDetails[0] && (
          <NumberQuestion
            table={table}
            firstColumnTitle={firstColumnTitle}
            tableId={tableId.toString()}
            percentage={percentage[tableId]}
            renderStats={!isChoiceQuestion}
          />
        )}
        {table && csvQuestionDetails[0] && (
          <>
            {questionType === NUMBER || isChoiceQuestion ? (
              <HorizontalTable
                data={table.anwser}
                percentage={percentage[tableId]}
                tableId={`table_${tableId}`}
                subQuestionDetails={questionDetails}
                firstColumnTitle={firstColumnTitle}
                useZAxisValue={parameters?.groupByColumnKey === "project"}
              />
            ) : (
              <TextTable
                data={table.anwser}
                tableId={`table_${tableId}`}
                subQuestionDetails={questionDetails}
                firstColumnTitle={firstColumnTitle}
                years={selectedYears}
              />
            )}
          </>
        )}
      </>
    );
  };

  return (
    !isSubQuestion && (
      <Fragment key={uuid.v4()}>
        <Accordion.Header
          className="flex-center flex-nowrap"
          as={Card.Header}
        >
          <QuestionIcon type={iconClass} className="me-2" />
          <span className="flex-grow-1 text-break" style={{ minWidth: 0 }}>
            {questionTitle}
            {renderTooltips(table)}
          </span>
          <HeaderOptions
            table={table}
            handleBeginningClick={handleBeginningClick}
            sinceBeginning={sinceBeginning}
          />
        </Accordion.Header>
        <Accordion.Body>
          <Card>
            <Card.Header>
              <CollapsibleCardHeader
                data={table.anwser}
                baseQuestionId={table.questionId}
                baseColumnType={questionType}
                baseQuestionTitle={table.questionTitle}
                shortcutType={pivotShortcut[table.questionId]?.shortcutType}
                isSubquestion={false}
                baseQuestionType={questionType}
                baseQuestionKey={table.questionKey}
                baseQuestionColumnKey={table?.anwser?.tableIdentifier?.columnKey}
                baseQuestionRowKey={table?.anwser?.tableIdentifier?.rowKey}
                baseQuestionGroupKey={""}
                chartMode={chartMode}
                handleClickDownloadQuestion={handleClickDownloadPivotQuestion}
                handleModalOpen={handleModalOpen}
                handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                handleSelectChartModeTable={handleSelectTableMode}
                handleSelectChartModeChart={handleSelectChartMode}
                onPercentageClick={handlePercentageClick}
                baseQuestionString={getQuestionPath(questionTitle)}
                groupByQuestionString={
                  csvQuestionDetails[0]?.questionId === table.questionId ? getBreadcrumbPath(table.questionId) : ""
                }
                percentageOn={percentage}
                checked={sinceBeginning[table.questionId] ? sinceBeginning[table.questionId] : false}
                status={status}
                periodCount={table.periodCount}
                renderBreadcrumb={csvQuestionDetails[0]?.questionId === table.questionId}
                onRenderBreadcrumb={() => renderPivotBreadcrumb(table.questionId)}
              />
            </Card.Header>
            <Card.Body>
              {!chartMode || chartMode === CHART_MODE_TABLE
                ? renderCSVTypeTable(
                    table,
                    csvQuestionDetails,
                    questionType,
                    questionDetails,
                    questionDetails
                      ? pivotShortcut[table.questionId]?.firstColumnTitle
                        ? pivotShortcut[table.questionId]?.firstColumnTitle
                        : parameters?.firstColumnTitle
                      : null,
                    table.questionId
                  )
                : renderChart(
                    table.anwser,
                    questionDetails,
                    questionType,
                    parameters?.groupByColumnName,
                    parameters?.groupByColumnKey
                  )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Fragment>
    )
  );
};

CSVTypeQuestion.propTypes = {
    table: PropTypes.object,
    subQuestion: PropTypes.object,
    collapsibleTablesDetails: PropTypes.object,
    modalSelectParameters: PropTypes.object,
    renderHeader: PropTypes.func,
    renderChart: PropTypes.func,
    renderPivotBreadcrumb: PropTypes.func,
    renderTooltips: PropTypes.func,
    handleClickDownloadPivotQuestion: PropTypes.func,
    handleModalOpen: PropTypes.func,
    handlePivotShortcutSubmit: PropTypes.func,
    handleBeginningClick: PropTypes.func,
    handlePercentageClick: PropTypes.func,
    getQuestionPath: PropTypes.func,
    getBreadcrumbPath: PropTypes.func,
    pivotShortcut: PropTypes.object,
    percentage: PropTypes.object,
    sinceBeginning: PropTypes.object,
    tabActive: PropTypes.string,
    subQuestionTitle: PropTypes.string,
    csvQuestionDetails: PropTypes.array,
    status: PropTypes.string,
    label: PropTypes.array
};

export default CSVTypeQuestion;
